import React from "react";
import "./styles.css";

function Contact() {
  return (
    <div className="contact-container">
      <section className="about-hero">
        <h1>Contact Us</h1>
      </section>

      <section className="contact-main">
        <div className="contact-grid">
          <div className="contact-card">
            <div className="contact-details">
              <p>
                <strong>Address:</strong>
                <br />
                1443 S Belcher Rd
                <br />
                Clearwater, FL 33764
              </p>

              <p>
                <strong>Phone:</strong>
                <br />
                <a href="tel:727-223-5153">📞 (727) 223-5153</a>
              </p>

              <p>
                <strong>Email:</strong>
                <br />
                <a href="mailto:chef@cafemasse.com">chef@cafemasse.com</a>
              </p>
            </div>

            <div className="contact-hours">
              <h2>Business Hours</h2>
              <p>Tuesday – Thursday: 5pm – 8pm</p>
              <p>Friday – Saturday: 5pm – 9pm</p>
              <p>Sunday: 5pm – 8pm</p>
              <p>Monday: Closed</p>
            </div>
          </div>

          <div className="contact-map">
            <iframe
              title="Cafe Masse Location"
              src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3514.3243165037663!2d-82.74349398509418!3d27.94410928268995!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x88c2e7d8b6e40ffb%3A0xe73fc09bb0d1a703!2s1443%20S%20Belcher%20Rd%2C%20Clearwater%2C%20FL%2033764!5e0!3m2!1sen!2sus!4v1681234567890!5m2!1sen!2sus"
              width="100%"
              height="350"
              allowFullScreen=""
              loading="lazy"
              referrerPolicy="no-referrer-when-downgrade"
            ></iframe>
            <div className="map-directions">
              <a
                href="https://www.google.com/maps/dir/?api=1&destination=1443+S+Belcher+Rd,+Clearwater,+FL+33764"
                target="_blank"
                rel="noopener noreferrer"
                className="directions-button"
              >
                Get Directions
              </a>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
}

export default Contact;
